export const homePath = '/';
export const settingsCodeReviewerPath = '/code-reviewer';
export const settingsCodePlannerPath = '/code-planner';
export const boysenberryPath = '/flow';
export const boysenberryCreateEmbedPath = '/flow/create/embed';
export const boysenberryFlowPath = '/flow/s/:flowId';
export const boysenberryCodePagePath = '/flow/s/:flowId/code';
